'use strict';

// Vue
import Vue from 'vue';

// Services
import { arrayLoop } from 'services/array';

// API
import {
  getNomenclature,
  getReviewRequests,
  getReviewRequestById,
  submitReview,
  requestReviewId,
  requestReviewPostInfo,
  requestReviewUploadImage,
  getReviewRequestsDoctor,
  getReviewRequestsDoctorById,
  getNextReview,
} from 'api/review';

// State
const state = {
  nomenclature: {},
  requests: {
    next: ``,
    count: 0,
    results: {},
  },
};

// Getters
const getters = {
  reviewNomenclature: state => state.nomenclature,
  reviewRequests: state => state.requests,
  reviewRequestsById: state => id => state.requests.results[id] || {},
  reviewRequestsLength: (state, getters) => Object.keys(getters.reviewRequests.results).length,
  reviewRequestsTotal: state => state.requests.count,
  reviewNomenclatureBySlug: state => slug => {
    const items = [];

    arrayLoop(state.nomenclature[slug] || [], (i, item) => {
      items.push({
        option: item.name,
        value: item.id,
      });
    });

    return items;
  },
  reviewNomenclatureBySlugAndId: (state, getters) => (slug, id) => {
    const nomenclature = getters.reviewNomenclatureBySlug(slug) || [];
    const nomenclatureFilter = nomenclature.filter(item => item.value === id) || [];
    return nomenclatureFilter.length ? nomenclatureFilter[0].option : ``;
  },
};

// Mutations
const mutations = {
  SET_NOMENCLATURE (state, nomenclature) {
    Vue.set(state, `nomenclature`, nomenclature);
  },
  CLEAR_REVIEWS (state) {
    Vue.set(state.requests, `results`, {});

    state.requests.next = ``;
    state.requests.count = 0;
  },
  UPDATE_REVIEWS (state, { results, next, count }) {
    arrayLoop(results, (i, result) => Vue.set(state.requests.results, result.id, result));

    state.requests.next = next;
    state.requests.count = count;
  },
  UPDATE_REVIEW_BY_ID (state, review) {
    Vue.set(state.requests.results, review.id, review);
  },
  RESET_ON_LOGOUT (state) {
    Vue.set(state, `requests`, {
      next: ``,
      count: 0,
      results: {},
    });
  },
};

// Actions
const actions = {
  getNomenclature({ commit }) {
    return new Promise((resolve, reject) => {
      getNomenclature()
        .then(res => {
          commit(`SET_NOMENCLATURE`, res.data);
          resolve(res.data);
        })
        .catch(err => {
          console.warn(`Nomenclature Err`, err);
          reject(err);
        });
    });
  },
  getReviewRequests({ commit }, url = false) {
    if (!url) {
      commit(`CLEAR_REVIEWS`);
    }

    return new Promise((resolve, reject) => {
      getReviewRequests(url)
        .then(res => {
          const data = res.data || {};
          const results = data.results || [];

          if (results.length) {
            commit(`UPDATE_REVIEWS`, data);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getReviewRequestsDoctor({ commit }, url = false) {
    if (!url) {
      commit(`CLEAR_REVIEWS`);
    }

    return new Promise((resolve, reject) => {
      getReviewRequestsDoctor(url)
        .then(res => {
          const data = res.data || {};
          const results = data.results || [];

          if (results.length) {
            commit(`UPDATE_REVIEWS`, data);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getReviewRequestsDoctorById({ commit }, id) {
    return new Promise((resolve, reject) => {
      getReviewRequestsDoctorById(id)
        .then(res => {
          const data = res.data || {};
          commit(`UPDATE_REVIEW_BY_ID`, data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getReviewRequestById(context, id) {
    return getReviewRequestById(id);
  },
  getNextReview,
  requestReviewId(context, model) {
    return requestReviewId(model);
  },
  requestReviewPostInfo(context, model) {
    return requestReviewPostInfo(model);
  },
  requestReviewUploadImage(context, model) {
    return requestReviewUploadImage(model);
  },
  submitReview(context, model) {
    return submitReview(model);
  },
  resetOnLogout({ commit }) {
    commit(`RESET_ON_LOGOUT`);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./client/store/review.js